import React, { Component } from 'react'
import { Header, Button, Columns } from 'components/elements'
import { ENDORSEMENT_QUESTION } from '../main/constants.js'
import './insuranceScreen.css'

class EndorsementQuestionScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      generalError: false,
      endorsementError: false,
      screenSize: 'mini',
    }
  }

  componentDidMount() {
    this.props.onScreenLoad(ENDORSEMENT_QUESTION)
  }

  render() {
    return (
      <div>
        {!this.state.endorsementError && (
          <React.Fragment>
            <Header
              size={5}
              className="has-text-weight-extra-bold mt-6 has-text-centered"
            >
              Do you have a motorcycle endorsement on your license?
            </Header>
            <div
              style={{
                textAlign: 'center',
                marginTop: '4rem',
                marginBottom: '4rem',
              }}
            ></div>
            <Columns className="is-mobile">
              <Columns.Column size={6}>
                <Button
                  size="medium"
                  fullwidth
                  outlined
                  type="button"
                  onClick={() => this.props.onSuccess()}
                >
                  Yes
                </Button>
              </Columns.Column>
              <Columns.Column size={6}>
                <Button
                  size="medium"
                  fullwidth
                  outlined
                  type="button"
                  onClick={() => {
                    this.setState({
                      endorsementError: true,
                    })
                  }}
                >
                  No
                </Button>
              </Columns.Column>
            </Columns>
          </React.Fragment>
        )}
        {this.state.endorsementError && (
          <div className="has-text-centered">
            <Header size={3} className="has-text-weight-extra-bold">
              Sorry.
            </Header>
            <i className="fal fa-frown-open fa-8x has-text-danger"></i>
            <p className="has-text-weight-bold mb-4">
              You must have a motorcycle endorsement to rent through Twisted
              Road.
            </p>
            <a
              className="button gold-button is-medium is-fullwidth has-text-weight-bold is-primary"
              href="/"
            >
              Got It.
            </a>
          </div>
        )}
      </div>
    )
  }
}
export default EndorsementQuestionScreen

EndorsementQuestionScreen.defaultProps = {
  onSuccess: function() {},
  skippable: false,
  header: 'License Endorsement Question',
  onScreenLoad: function() {},
}
